import './UserLogin.scss';
import React, { Component } from 'react';
import DisneyHero from '../disney-hero/DisneyHero';

export default class UserLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            consent: false,
            showDetailsForm: false
        }

        this.firstNameRef = React.createRef();
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleConsentChange = this.handleConsentChange.bind(this);
        this.handleJoinClick = this.handleJoinClick.bind(this);
    }

    isDisneyTheme = () => {
        return this.props.theme === 'disney' || this.props.theme === 'disney-toy-story-5';
    }

    isDisneyCompactIntro = () => {
        return this.props.compactIntro && this.isDisneyTheme();
    }

    isPreJoin = () => {
        return this.isDisneyCompactIntro() && !this.state.showDetailsForm;
    }

    syncPreJoinBodyClass = () => {
        document.body.classList.toggle('theme-disney-prejoin', this.isDisneyCompactIntro());
    }

    focusFirstName = () => {
        if (this.firstNameRef.current) {
            this.firstNameRef.current.focus();
        }
    }

    handleFirstNameChange(event) {
        this.setState({firstName: event.target.value});
    }

    handleLastNameChange(event) {
        this.setState({lastName: event.target.value});
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value});
    }

    handleConsentChange(event) {
        this.setState({consent: !this.state.consent});
    }

    handleJoinClick() {
        this.setState({showDetailsForm: true});
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const isDisneyTheme = this.isDisneyTheme();
        const email = isDisneyTheme ? '' : this.state.email;

        if (!this.state.firstName || !this.state.lastName || (!isDisneyTheme && !this.state.email)) {
            return;
        }

        this.props.onSubmit(this.state.firstName, this.state.lastName, email, this.state.consent);
    }

    componentDidMount() {
        this.focusFirstName();
        this.syncPreJoinBodyClass();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.showDetailsForm && this.state.showDetailsForm) {
            this.focusFirstName();
        }

        if (prevProps.compactIntro !== this.props.compactIntro || prevProps.theme !== this.props.theme || prevState.showDetailsForm !== this.state.showDetailsForm) {
            this.syncPreJoinBodyClass();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('theme-disney-prejoin');
    }

    renderDisneyHero = () => {
        if (!this.isDisneyCompactIntro()) {
            return null;
        }

        return <DisneyHero showBrandRow={true} />;
    }

    render() {
        const compactIntro = this.props.compactIntro;
        const isDisneyTheme = this.isDisneyTheme();
        const isDisneyCompactIntro = this.isDisneyCompactIntro();
        const isToyStory5Theme = this.props.theme === 'disney-toy-story-5';
        const showDetailsForm = !compactIntro || !isDisneyTheme || this.state.showDetailsForm;
        const className = `user-login mt-3 mt-md-5${compactIntro ? ' user-login--compact-intro' : ''}${isDisneyCompactIntro ? ' user-login--compact-disney' : ''}${isDisneyCompactIntro && showDetailsForm ? ' user-login--form-open' : ''}${!showDetailsForm ? ' user-login--prejoin' : ''}`;
        const detailsClassName = `user-login__details-shell${isDisneyCompactIntro && showDetailsForm ? ' user-login__details-shell--overlay' : ''}`;
        const introClassName = `user-login__intro ${compactIntro ? 'mb-3' : 'mb-5'}`;
        const introText = isToyStory5Theme
            ? 'WELCOME TO THE TOY STORY 5 QUIZ'
            : 'Welcome to the TEAM LEWIS interactive voting tool, please register your details below and we will take it from there';

        return (
            <div className={className}>
                {this.renderDisneyHero()}

                {!showDetailsForm &&
                <button type="button" className="btn home-submit user-login__join-button" onClick={this.handleJoinClick}>JOIN THE QUIZ</button>
                }

                {showDetailsForm &&
                <div className={detailsClassName}>
                {(!compactIntro || isToyStory5Theme) &&
                <p className={introClassName}>
                    {introText}
                </p>
                }

                <form className='user-login__input-section'>
                    <div className='mb-3'>
                        <label htmlFor="firstName" className="form-label">First Name</label>
                        <input required ref={this.firstNameRef} type="text" id="firstName" className="form-control" value={this.state.firstName} onChange={this.handleFirstNameChange} />
                    </div>
                    <div className='mb-4'>
                        <label htmlFor="lastName" className="form-label">Last Name</label>
                        <input required type="text" id="lastName" className="form-control" value={this.state.lastName} onChange={this.handleLastNameChange} />
                    </div>
                    {!isDisneyTheme &&
                    <div className='mb-4'>
                        <label htmlFor="email" className="form-label">Email</label>
                        <input required type="text" id="email" className="form-control" value={this.state.email} onChange={this.handleEmailChange} />
                    </div>
                    }
                    {!compactIntro &&
                    <div className="form-check mb-4">
                        <input type="checkbox" id="consent" className="form-check-input" checked={this.state.consent} value="true" onChange={this.handleConsentChange} />
                        <label htmlFor="consent" className="form-check-label">I would like to opt-in to receive communications from TEAM LEWIS. Our <a className='user-login__terms' target='_blank' rel="noreferrer nofollow" href="https://www.teamlewis.com/uk/privacy-centre/">privacy policy</a>.</label>
                    </div>
                    }
                    <button type="submit" id="submitDetails" className="btn home-submit" onClick={this.handleSubmit}>Submit</button>
                </form>
                </div>
                }
            </div>
        );
    }
}
